import type { ICluster } from '@/types/cluster'
import { CLUSTERS } from '@/lib/constants/clusters'
export const CLUSTERS_TEXT: Record<ICluster, string> = {
  [CLUSTERS.INFORMATION_SECURITY_MANAGEMENT_SYSTEM]: 'Sistema de Gestión de Seguridad de la Información',
  [CLUSTERS.PEOPLE]: 'Gestión de personal',
  [CLUSTERS.PHYSICAL_SECURITY]: 'Seguridad Física',
  [CLUSTERS.ASSET_MANAGEMENT]: 'Gestión de Activos',
  [CLUSTERS.DATA_PROTECTION]: 'Protección de Datos',
  [CLUSTERS.IDENTITY_ACCESS_MANAGEMENT]: 'Gestión de Identidad y Accesos',
  [CLUSTERS.NETWORKING_SECURITY]: 'Seguridad de Redes',
  [CLUSTERS.OPERATIONS_SECURITY]: 'Seguridad de Operaciones',
  [CLUSTERS.CONFIGURATION_MANAGEMENT]: 'Gestión de Configuración',
  [CLUSTERS.SECURE_DEVELOPMENT]: 'Desarrollo Seguro',
  [CLUSTERS.CHANGE_MANAGEMENT]: 'Gestión de Cambios',
  [CLUSTERS.RISK_MANAGEMENT]: 'Gestión de Riesgos',
  [CLUSTERS.INCIDENT_RESPONSE]: 'Respuesta a Incidentes',
  [CLUSTERS.BUSINESS_CONTINUITY]: 'Continuidad de Negocio',
  [CLUSTERS.SUPPLY_CHAIN]: 'Cadena de Suministro',
  [CLUSTERS.COMPLIANCE]: 'Compliance',
  [CLUSTERS.AUDIT_NON_CONFORMITIES]: 'No Conformidades',
  [CLUSTERS.AWARENESS]: 'Concienciación',
  [CLUSTERS.COMMUNICATIONS]: 'Comunicaciones',
  [CLUSTERS.CRYPTOGRAPHY]: 'Criptografía',
  [CLUSTERS.CUSTOMER_MANAGEMENT]: 'Gestión de Clientes',
  [CLUSTERS.INTEGRATED_MANAGEMENT_SYSTEM]: 'Sistema de Gestión Integrado',
  [CLUSTERS.OPERATIONS_MANAGEMENT]: 'Gestión de Operaciones',
  [CLUSTERS.QUALITY_MANAGEMENT]: 'Gestión de Calidad',
  [CLUSTERS.SALES_MANAGEMENT]: 'Gestión de Ventas',
  [CLUSTERS.INTERNAL_AUDIT]: 'Auditoría Interna',
}
export const NO_CLUSTER = 'Sin Cluster'

export const CLUSTER_SELECTOR = {
  SEARCH_CLUSTERS: 'Buscar clusters...',
  NO_CLUSTER_FOUND: 'No se encontró cluster.',
}
